import type { V2UnitDef } from "../types";

/**
 * Normalize unit definition to use canonical key names.
 * @param unit - Unit definition to normalize
 * @returns Normalized unit definition
 */
export function normalizeUnit(unit: V2UnitDef): V2UnitDef {
  return {
    text: unit.text,
    unitWidth: unit.unitWidth ?? unit.width,
    unitStyle: (unit.unitStyle ?? unit.style) as V2UnitDef["unitStyle"],
  };
}
